import { replace } from 'react-router-redux';

export const CREATE_CHAPTER = 'CREATE_CHAPTER';
export const UPDATE_CHAPTER = 'UPDATE_CHAPTER';
export const MOVE_CHAPTER_UP = 'MOVE_CHAPTER_UP';
export const MOVE_CHAPTER_DOWN = 'MOVE_CHAPTER_DOWN';
export const REMOVE_CHAPTER = 'REMOVE_CHAPTER';

function chapterCreated(fields) {
  return {
    type: CREATE_CHAPTER,
    payload: {
      ...fields,
    },
  };
}

export function createChapter(fields) {
  return dispatch => {
    dispatch(chapterCreated(fields));
    // Redirecting to chapter list
    dispatch(replace('/'));
  };
}

export function updateChapter(id, name) {
  return {
    type: UPDATE_CHAPTER,
    payload: {
      id,
      name,
    },
  };
}

export function moveChapterUp(chapter) {
  return {
    type: MOVE_CHAPTER_UP,
    payload: {
      chapter,
    },
  };
}

export function moveChapterDown(chapter) {
  return {
    type: MOVE_CHAPTER_DOWN,
    payload: {
      chapter,
    },
  };
}

export function removeChapter(chapter) {
  return {
    type: REMOVE_CHAPTER,
    payload: {
      chapter,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/memo/actions/chapters.js